import { Player } from '@lottiefiles/react-lottie-player';
import animationData from './97930-loading.json';

const LoadingAnimation = () => {
  return (
    <div
      className="animation_Container"
      style={{
        position: 'fixed',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.1)', // 반투명 배경
        pointerEvents: 'auto', // 부모 요소에서 클릭 이벤트 허용
      }}
    >
      <div
        style={{
          pointerEvents: 'none', // 자식 요소에서 클릭 이벤트 차단
        }}
      >
        <Player
          autoplay
          loop
          src={animationData}
          style={{
            display: 'block',
            height: '400px',
            width: '400px',
          }}
        />
      </div>
    </div>
  );
};

export default LoadingAnimation;
